// extracted by mini-css-extract-plugin
export default {"input":"RoeKy","inverted":"rAsUi"};